import { attr, belongsTo } from '@ember-data/model';
import Super from './document';

export default class PhotoId extends Super {
  @attr() file;

  @belongsTo('document-request-contact-info-connection', { async: false }) connection;
}
